import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import type { Maybe, UserRoleCodes } from '@/types'

import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'

import { ROLES_REDIRECT_PAGES } from '@/constants'

export function checkRights(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const authStore = useAuthStore()
  const { currentRole } = storeToRefs(authStore)

  const routeName = (to.name ?? '') as string

  const isManager = /manager/.test(routeName)
  if (!isManager) return next()

  if (!currentRole.value) return next({ name: 'manager-login' })

  const eligible = (to.meta.roles ?? []) as UserRoleCodes[]

  if (checkRole(currentRole.value, eligible) && routeName !== 'manager-home') {
    return next()
  }

  next(ROLES_REDIRECT_PAGES[currentRole.value] ?? { name: 'manager-login' })
}

export function checkRole(
  currentRole: Maybe<UserRoleCodes>,
  eligible?: UserRoleCodes[]
) {
  if (!eligible?.length) return true

  return currentRole ? eligible.includes(currentRole) : false
}
